module.exports = __webpack_public_path__ + "img/1F1F8-1F1EC.d62ec29f.svg";